import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {OidcSecurityService} from 'angular-auth-oidc-client';
import {firstValueFrom, Observable, tap} from 'rxjs';
import {ErrorUtil} from '../utilities/error.util';
import {HhsgSharedConfigService} from './config.service';
import {map, switchMap} from "rxjs/operators";

@Injectable()
export class HhsgSharedHttpInterceptor implements HttpInterceptor {

  constructor(private _configService: HhsgSharedConfigService, private _oidcSecurityService: OidcSecurityService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.shouldAddAuthToken(req) ? this.addAuthToken(req, next) : this.passThroughRequest(req, next);
  }

  shouldAddAuthToken(req: HttpRequest<any>) {
    return (req.url.includes(this._configService.appSettings.webApiServer) || req.url.includes(this._configService.appSettings.stsServer)) && !req.url.includes('connect/') && !req.url.includes('well-known');
  }

  addAuthToken(req: HttpRequest<any>, next: HttpHandler) {
    return this._oidcSecurityService.getAccessToken().pipe(switchMap(token => {
      let withCredentials = req.withCredentials;
      let headers = req.headers;
      let authorization = headers.get('Authorization');
      if (authorization === undefined || authorization === null) {
        if (token) {
          withCredentials = true;
          headers = headers.set('Authorization', `Bearer ${token}`);
        }
      }

      // Clone with new auth headers:
      req = req.clone({headers: headers, withCredentials: withCredentials});

      return next.handle(req).pipe(tap((event: any) => {
        return event;
      }, (error: any) => {
        return this.handleError(error);
      }));
    }));
  }

  passThroughRequest(req: HttpRequest<any>, next: HttpHandler) {
    return next.handle(req).pipe(tap((event: HttpEvent<any>) => {
      return event;
    }, (error: any) => {
      return this.handleError(error);
    }));
  }

  handleError(error: any) {
    if (error instanceof HttpErrorResponse) {
      if (error.status === 401) {
        ErrorUtil.logError('[http-interceptor] Forbidden!');
        return error;
      }
    }
    return error;
  }
}
